<script>
import CommonRules from "@/mixins/CommonRules";
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import _ from "lodash";
import VideoPlayer from "@/components/commonComponents/VideoPlayer.vue";
import VCurrencyInput from "@/components/commonComponents/VCurrencyInput.vue";

export default {
    name: "QuotesModalVideo",
    components: {
        VCurrencyInput,
        VideoPlayer,
        AjaxLoad,
    },
    mixins: [
        CommonRules,
    ],
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        idEventsBitrix: {
            type: Number,
        },
        idForumsBitrix: {
            type: Number,
        },
        isDisabledField: {
            type: Function,
        },
        active: {
            type: Boolean,
        },
    },
    data() {
        return {
            dictionaries: {
                sessions: [],
            },
            resolved: false,
            bootPlayer: false,
        };
    },
    computed: {
        session() {
            return _.find(this.dictionaries.sessions, {id_eps: this.value?.id_session_eps});
        },
        hasVideo() {
            return !!this.session?.URL_VIDEO_STREAM;
        },
        url() {
            return this.$apiUrl.getForumEventSessionsUrl(Object.assign(
                {},
                this.$route.params,
                _.pickBy({
                    ID_FORUM: this.idForumsBitrix,
                    ID_EVENT: this.idEventsBitrix
                }, _.isNumber)
            ));
        },
    },
    watch: {
        resolved(v) {
            this.$emit('update:resolved', v);
        },
        hasVideo(v) {
            this.$emit('update:has-video', v);
        },
        active(v) {
            this.bootPlayer = this.bootPlayer || v;
        },
    },
    methods: {
        transformResponse(response) {
            return response.data.data.items.map(v => ({
                id_eps: parseInt(v.ID_PD.VALUE),
                NAME: v.NAME,
                TRANSLATION: v.TRANSLATION?.VALUE,
                URL_VIDEO_STREAM: v.URL_VIDEO_STREAM?.VALUE,
            }));
        },
    },
}
</script>

<template>
    <v-container>
        <v-row>
            <v-col class="photo-wrapper">
                <v-card>
                    <v-card-text class="pa-4">
                        <ajax-load
                            :url="url"
                            :transform="transformResponse"
                            v-model="dictionaries.sessions"
                            :resolved.sync="resolved"
                        ></ajax-load>

                        <template v-if="hasVideo && bootPlayer">
                            <video-player :src="session.URL_VIDEO_STREAM" :time="value.start_time"></video-player>
                        </template>
                    </v-card-text>

                    <v-card-actions class="px-4">
                        <v-currency-input
                            v-model.number="value.start_time"
                            :options="{valueRange: {min: 0, max: 1e12}, precision: 3}"
                            :disabled="isDisabledField('start_time')"
                            :rules="[rules.positiveNumber]"
                            label="Тайм-код"
                            class="required"
                        ></v-currency-input>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>

</template>

<style scoped lang="scss">
::v-deep {
    .v-card__actions {
        border-top: 1px solid silver;
    }

    .photo-wrapper {
        //background-color: #00000016;
        padding: 2px;
        margin: 2px;
    }

    .v-card {
        margin: 0 auto;
    }
}
</style>
